export enum KioskStudentIdentifierState {
  BOC = 'BOC',
  SID = 'SID',
  IdentiKey = 'IdentiKey'
}

export interface KioskStudentIdentifierModel {
  identifier: string
  kioskState: KioskStudentIdentifierState
}
